export default {
  title: 'Udviklere',
  subtitle: 'API-nøgler, webhooks og leveringshistorik til din Partner API-integration.',
  no_account: 'Ingen Partner API-konto endnu — kontakt Foodamigos for at få oprettet en.',
  no_account_manage: 'Ingen Partner API-konto endnu — opret en for at begynde at udstede nøgler.',
  buttons: {
    new_account: 'Ny konto',
    edit_account: 'Rediger konto',
    docs: 'API-dokumentation',
  },
  tabs: {
    api_keys: 'API-nøgler',
    webhooks: 'Webhooks',
    deliveries: 'Leveringer',
  },
  toasts: {
    load_error: 'Dine Partner API-konti kunne ikke indlæses.',
  },
};
